import React, { useContext, useEffect, useRef } from "react";
import { LanguageContext } from "../../context/LanguageContext";

const Carousel = () => {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);

  useEffect(() => {
    loadLanguageFile("Gallery", "home/home_Gallery_lang");
  }, [language]);

  const LANGUAGE = componentLanguageData.Gallery || { Main: {} };
  return (
    <>
      <div className="container-fluid gallery py-5 px-0">
        <div className="text-center mx-auto pb-5" style={{ maxWidth: "800px" }}>
          <h5 className="text-uppercase text-primary">{LANGUAGE.Main.Content1}</h5>
          <h1 className="mb-4">{LANGUAGE.Main.Content2}</h1>
          <p className="mb-0">
            {LANGUAGE.Main.Content3}
          </p>
        </div>
        <div className="row g-0">
          <div className="col-lg-12">
            <div className="gallery-item">
              <img src={LANGUAGE.Main.Img} className="img-fluid w-100" alt="Gallery" />
              <div className="search-icon">
                <a
                  href={LANGUAGE.Main.Img}
                  data-lightbox="gallery-1"
                  className="my-auto"
                >
                  <i className="fas fa-search-plus btn-hover-color bg-white text-primary p-3"></i>
                </a>
              </div>
              <div className="gallery-content">
                <div className="gallery-inner pb-3 pt-3">
                  <a href={LANGUAGE.Main.Url_1} className="h4 text-white">
                    {LANGUAGE.Main.Content4}
                  </a>
                  {/* <a href={LANGUAGE.Main.Url_2} className="text-white">
                    <span className="mb-0">{LANGUAGE.Main.Content5}</span>
                  </a> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Carousel;
